import {
  UserConsent,
  functional,
  performance,
  targeting
} from "cookiesConsent/domain/consent"

export type ConsentState = `granted` | `denied`

const granted: ConsentState = `granted`
const denied: ConsentState = `denied`

export class GtmConsentSignal {
  private readonly signals: Record<string, ConsentState>

  constructor(signals: Record<string, ConsentState>) {
    this.signals = signals
  }

  forGtm = (): Record<string, ConsentState> => ({ ...this.signals })

  equals = (other: GtmConsentSignal): boolean =>
    JSON.stringify(this.signals) === JSON.stringify(other.signals)
}

export class GtmConsentSignalFactory {
  fromConsent = (consent: UserConsent): GtmConsentSignal =>
    new GtmConsentSignal({
      analytics_storage: consent.permits(performance) ? granted : denied,
      ad_storage: consent.permits(targeting) ? granted : denied,
      ad_user_data: consent.permits(targeting) ? granted : denied,
      ad_personalization: consent.permits(targeting) ? granted : denied,
      functionality_storage: consent.permits(functional) ? granted : denied,
      personalization_storage: consent.permits(functional) ? granted : denied,
      security_storage: granted
    })
}
